import React from 'react';
import useAuth from '../hooks/useAuth';


function SubscriptionDetailsMobile() {
    const { auth } = useAuth();
    return (
        <div style={{ paddingTop: "20px", paddingLeft: "10px" }} >
            <div style={{ fontWeight: "600", fontSize: "16px", textAlign: "left" }}>
                Subscription Details
            </div>
            <div style={{ paddingLeft: "10px", paddingTop: "50px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "auto", maxWidth: "800px" }}>
                    {auth.user ?
                        <div style={{ textAlign: "left" }}>
                            {auth.roles ? <div style={{ padding: "20px 0px" }}>You are suscribed to our Premium Membership.</div>
                                : <div style={{ padding: "20px 0px" }}>You are not suscribed to our Premium Membership.</div>
                            }
                            <div style={{ display: "flex", gap: "10px" }}>
                                <div style={{ paddingTop: "10px" }}> API Key:</div>
                                <div style={{ backgroundColor: "white", padding: "10px 40px", color: "#C41E3A", border: "2px solid #C41E3A", borderRadius: "5px", cursor: "pointer", minWidth:"100px" }}>{auth.key}</div>
                            </div>
                        </div>
                        :
                        <div style={{ textAlign: "left" }}>Please login to get your private key</div>
                    }

                </div>
            </div>
        </div>
    );
}
export default SubscriptionDetailsMobile;